import { useMemo } from "react"
import calendarStyles from "../../../styles/EventsCalendarStyles"
import { MonthView } from "@devexpress/dx-react-scheduler-material-ui"
import { useTheme } from '@mui/material/styles'


export const tableBodyMonth = (props: any) => {
  const theme = useTheme()
  const classes = useMemo(
    () =>
      calendarStyles(theme, {
        top: 0,
        shadedHeight: 0,
        backgroundColor: '',
        color: ''
      }),
    [theme]
  )
  return <MonthView.TimeTableLayout {...props} sx={classes.monthBody} />
}